/*global Modernizr, TweenMax, console */
/*jslint browser:true */

(function() {
  'use strict';

  var scribbles = document.querySelectorAll('.scribble');

  scribbles.forEach((scribble) => {
    window.addEventListener('mousemove', (e) => {
      parallaxIt(e, scribble);
    });
  });

  function parallaxIt(e, target) {
    var movement = 5,
        windowWidth = (window.innerWidth || document.documentElement.clientWidth),
        windowHeight = (window.innerHeight || document.documentElement.clientHeight),
        relX = ((((e.clientX - (windowWidth / 2)) / windowWidth) * 100) / 50) * movement,
        relY = ((((e.clientY - (windowHeight / 2)) / windowHeight) * 100) / 50) * movement;

    TweenMax.to(target.querySelector('svg'), 1, {
      x: relX,
      y: relY
    });
  }

  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
  }

  function getOffset(el) {
    var box = el.getBoundingClientRect();
    var docElem = document.documentElement;
    return {
      top: box.top + window.pageYOffset - docElem.clientTop,
      left: box.left + window.pageXOffset - docElem.clientLeft
    };
  }
}());